// @flow
type SetBillingDetailsForcedByZooz = {|
  type: "SET_BILLING_DETAILS_FORCED_BY_ZOOZ",
  payload: boolean,
|}

type SetInfantsFareSupported = {|
  type: "SET_INFANTS_FARE_SUPPORTED",
  payload: boolean,
|}

export type Action = SetBillingDetailsForcedByZooz | SetInfantsFareSupported

export const setBillingDetailsForcedByZooz = (
  billingDetailsForcedByZooz: boolean,
): SetBillingDetailsForcedByZooz => ({
  type: "SET_BILLING_DETAILS_FORCED_BY_ZOOZ",
  payload: billingDetailsForcedByZooz,
})
export const setInfantsFareSupported = (
  infantsFareSupported: boolean,
): SetInfantsFareSupported => ({
  type: "SET_INFANTS_FARE_SUPPORTED",
  payload: infantsFareSupported,
})
